import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

const Privacy = () => {
  return (
    <div>
        <Header />
        <div style={{ padding: "20px", lineHeight: "1.6" }}>
            <h1>AVISO DE PRIVACIDAD INTEGRAL</h1>
            <p>
                HERDEZ, S.A. DE C.V., (en lo sucesivo el “Responsable”) con domicilio en
                Calzada San Bartolo Naucalpan, número 360, Colonia Argentina Poniente,
                Alcaldía Miguel Hidalgo, Ciudad de México, C.P.11230, es el responsable
                del tratamiento de los datos personales que nos proporcione, los cuales
                serán protegidos conforme a lo dispuesto por la Ley Federal de
                Protección de Datos Personales en Posesión de los Particulares, su
                Reglamento y demás normatividad que resulte aplicable, y al respecto le
                informamos lo siguiente:
            </p>

            <h2>¿QUÉ DATOS PERSONALES RECABAMOS?</h2>
            <p>
                Para llevar a cabo las finalidades descritas en el presente Aviso de
                Privacidad, podremos recabar de nuestros clientes, consumidores y
                público en general a través de nuestros sitios web, aplicaciones, redes
                sociales, de forma personal o vía telefónica los siguientes datos e
                información:
            </p>
            <ul>
                <li>Nombre completo.</li>
                <li>Fecha de nacimiento.</li>
                <li>Edad.</li>
                <li>Género.</li>
                <li>Correo electrónico.</li>
                <li>Teléfono fijo o celular.</li>
                <li>
                Domicilio: calle y número, colonia, ciudad, estado, código postal y
                país.
                </li>
                <li>
                Credencial de elector: clave de elector, CURP, firma, fotografía,
                huella dactilar, OCR.
                </li>
            </ul>
            <p>
                Se informa que, para las finalidades previstas en el presente Aviso de
                Privacidad, no se recabarán de usted Datos Personales sensibles.
            </p>

            <h2>¿PARA QUÉ FINES RECABAMOS TUS DATOS PERSONALES?</h2>
            <p>
                Tu información personal será utilizada para las siguientes finalidades
                primarias, las cuales son necesarias para proporcionarte nuestros
                productos y/o servicios:
            </p>
            <ul>
                <li>Identificarte y contactarte.</li>
                <li>Validar tu identidad.</li>
                <li>
                Proporcionarte la información que nos solicites sobre nuestros
                productos y/o servicios, así como enviarte cotizaciones.
                </li>
                <li>Compartirle nuestras iniciativas y campañas.</li>
                <li>Permitirte disfrutar de nuestros juegos en la página web.</li>
                <li>Facilitarle el enlace a nuestras redes sociales.</li>
                <li>Compartir recetas elaboradas con nuestros productos.</li>
                <li>
                Inscribirte a los programas, promociones, concursos y/o eventos que
                nos solicites.
                </li>
                <li>
                Proporcionarte los productos que nos solicites o contrates con
                nosotros, así como brindarte los beneficios que ofrecemos a través de
                nuestros diferentes programas, cursos, eventos en los que tú
                participes.
                </li>
                <li>
                En caso de resultar ganador o beneficiario de algún incentivo u
                obsequio, hacerte entrega del mismo.
                </li>
                <li>Documentar y darte solución a problemáticas de servicio.</li>
                <li>
                Atención y seguimiento de tus dudas, aclaraciones, quejas o
                sugerencias.
                </li>
                <li>
                Elaborar y mantener actualizada nuestra base de datos de consumidores
                y prospectos de consumidores.
                </li>
                <li>Cumplimiento de disposiciones legales y/o contractuales.</li>
            </ul>
            <p>
            Además de utilizarse para las finalidades primarias, tus datos personales serán 
            empleados para otras finalidades secundarias que, aunque no son esenciales, 
            resultan altamente beneficiosas, para mejorar la calidad de nuestra atención, 
            perfeccionar nuestros productos y llevar a cabo actividades publicitarias y 
            promocionales relacionadas con ellos. A continuación, se enlistan:
            </p>
            <ul>
                <li>Construir perfiles de consumo.</li>
                <li>Informarte y posibilitar tu participación en concursos con fines publicitarios y/o promocionales.</li>
                <li>Enviarte información, publicidad y/o promociones, a través de nuestros newsletters.</li>
                <li>Realizar actividades mercadotécnicas, publicitarias y de prospección comercial.</li>
                <li>Obtener tus comentarios sobre los servicios y/o productos proporcionados.</li>
                <li>Contactarte por cualquier medio de comunicación con el objeto de ofrecerte nuestros productos.</li>
                <li>Elaborar listados de exclusión con el objeto de registrar de manera gratuita su negativa al tratamiento de sus datos personales.</li>
            </ul>
            <h2>¿NO ESTÁS DE ACUERDO CON LAS FINALIDADES SECUNDARIAS? ¿CÓMO PUEDES NEGARTE?</h2>
            <p>
            Si no deseas que tus datos personales sean tratados para las finalidades secundarias 
            señaladas, o alguna de ellas, puedes negarnos tu consentimiento desde este momento 
            enviando tu solicitud al siguiente correo electrónico: protecciondedatos@herdez.com. 
            Tu negativa no afectará las finalidades primarias ni será motivo para dejar de proporcionarte 
            nuestros productos y servicios.
            </p>
        </div>
        <Footer />
    </div>
    
  );
};

export default Privacy;
